/* eslint-disable import/prefer-default-export */
export const specificMarketColors = [
    "#14B2E2",
    "#6AD1F0",
    "#00C18D",
    "#33CDA4",
    "#E54D42",
    "#EF948E",
    "#F18600",
    "#F7B666",
    "#AB55A3",
    "#CD99C8"
];

export const audienceSpicificColors = [...specificMarketColors];

export const behaviorMatchColors = [
    "#00C18D",
    "#14B2E2",
    "#FCA522",
    "#E54D42"
];
